module.exports = __webpack_public_path__ + "img/pythonblog.png.2e630709.webp";